import { Component, Suspense, type ReactNode } from 'react';
import { ErrorBox, Loading } from '../../components/ui.tsx';
import { MSG } from '../../content/messages.ts';

interface State {
  failed: boolean;
}

/**
 * One perspective block loaded on demand: its code arrives as a separate chunk, which can fail to download (a phone
 * that lost signal), and its answer comes from another endpoint. Either failure stays inside the block, so the rest
 * of the panel remains on screen; "Tentar novamente" renders the block again.
 */
export class BlockBoundary extends Component<{ children: ReactNode; what?: string }, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override render() {
    if (this.state.failed) {
      return (
        <section className="card" data-testid="dashboard-block-failed">
          <ErrorBox error={MSG.errors.unexpected} retry={() => this.setState({ failed: false })} />
        </section>
      );
    }
    return <Suspense fallback={<Loading what={this.props.what} />}>{this.props.children}</Suspense>;
  }
}
